export default __webpack_public_path__ + "static/media/flippyknife_demo_image.e7d80948.png";